import React from 'react';
import styled from 'styled-components';
import {TextInputLoader} from 'design-system/src/Components/ContentLoader';

const LoaderContainer = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 418px;
  gap: 8px;
`;

const SignUpFormLoader: React.FC = () => (
  <LoaderContainer>
    {Array.from({length: 8}).map((_, index) => (
      <TextInputLoader key={index} />
    ))}
  </LoaderContainer>
);

export default SignUpFormLoader;